module.exports = __webpack_public_path__ + "img/user.ad6181b.jpg";